import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cookies are httpOnly + same-origin via the ingress, so withCredentials is enough.
// No Authorization header injection from JS — protects against XSS token theft.
export const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);
